import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import { onMounted, reactive, ref } from 'vue'
import { useStore } from '@/store'
import SelectChannel from '@/components/SelectChannel.vue'
import Keys from '@/constant/key';
import { joinParams } from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceData',
  setup(__props) {

const store = useStore()
const user_id = store.state.user.userInfo.id
const username = store.state.user.userInfo.username

const filters = reactive({
    channel_no: '',     // 渠道号
    start_time: '',     // 开始日期
    end_time:   '',     // 结束日期
    start:      '',     // 开始月份
    end:        ''      // 结束月份
})

// 渠道变化监听
const onChannelChange = (val) => {
    filters.channel_no = val ? val.channel_no : ''
}

// 导出
const onExport = (url) => {
    const params = joinParams({
        ...filters,
        user_id,
        user_name: username
    })

    let downUrl = `${Keys.baseUrl}${url}${url.indexOf('?') > -1 ? '&' : '?'}${params}`
    window.open(downUrl)
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "渠道：", -1)),
          _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "按日期：", -1)),
          _createVNode(_component_el_date_picker, {
            class: "filter-item",
            modelValue: filters.start_time,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.start_time) = $event)),
            "value-format": "YYYY-MM-DD",
            placeholder: "开始日期"
          }, null, 8, ["modelValue"]),
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
          _createVNode(_component_el_date_picker, {
            class: "filter-item",
            modelValue: filters.end_time,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.end_time) = $event)),
            "value-format": "YYYY-MM-DD",
            placeholder: "结束日期"
          }, null, 8, ["modelValue"]),
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "按月份：", -1)),
          _createVNode(_component_el_date_picker, {
            class: "filter-item",
            modelValue: filters.start,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.start) = $event)),
            type: "month",
            "value-format": "YYYY-MM",
            placeholder: "开始月份"
          }, null, 8, ["modelValue"]),
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
          _createVNode(_component_el_date_picker, {
            class: "filter-item",
            modelValue: filters.end,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.end) = $event)),
            type: "month",
            "value-format": "YYYY-MM",
            placeholder: "结束月份"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { header: "绑定率" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onExport('/cake/caed_info')))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("全部绑定率")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onExport('/cake/caed_info_all')))
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("全部绑定率（不包含工福）")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (onExport('/cake/caed_gf')))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("工福绑定率")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { header: "消耗数据统计" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (onExport('/finance/orderExcel')))
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("实物消耗统计")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (onExport('/finance/couponExcel')))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("电子券消耗统计")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (onExport('/finance/move_excel')))
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode("电影消耗统计")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { header: "卡券SaaS数据" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (onExport('/coupon/offline_coupon/warehouseOutboundList?is_return=1&export=1')))
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode("总库渠道出库退款记录")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { header: "其他数据" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (onExport('/admin/fine_order/exportCouponChannelOrder')))
        }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [
            _createTextVNode("H5对接渠道电子券对账单")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})